import Cookie from 'js-cookie';
import uuid from 'uuid';

export type SegmentCookieUser = {
  conciergeUser?: any | null;
  shoppingWithCeoUser?: any | null;
  email?: string;
};

const checkSegmentCookie = (user: SegmentCookieUser | null) => {
  if (!Cookie.get('OHSegmentId')) {
    const segmentId = uuid.v4();
    Cookie.set('OHSegmentId', segmentId, { expires: 365 });
  }

  if (user) {
    const { shoppingWithCeoUser, conciergeUser } = user;
    const isShoppingWithAnother = conciergeUser || shoppingWithCeoUser;

    if (isShoppingWithAnother) {
      const conciergeCookie = Cookie.get('OHSegmentId');
      if (isShoppingWithAnother.email) {
        // Should use the email as the uerId
        if (isShoppingWithAnother.email !== conciergeCookie) {
          Cookie.set('OHSegmentId', isShoppingWithAnother.email, {
            expires: 365,
          });
        }
      } else {
        Cookie.set('OHSegmentId', null, { expires: 365 });
      }
    }
    // @ts-ignore: analytics is a global variable
    if (typeof analytics !== 'undefined' && !!analytics._user) {
      if (user.email) {
        // @ts-ignore: analytics is a global variable
        analytics._user.id(user.email);
      } else {
        // @ts-ignore: analytics is a global variable
        analytics._user.id(null);
      }
    }
  }
};

export default checkSegmentCookie;
